interface TermsVersion {
  url?: string | null;
  fileUrl?: string | null;
}

/**
 *
 * @param termsVersion - A terms version object from the API response.

 * @returns the embedded and full-screen URLs for the latest terms version.
 * Defaults to url, and falls back to fileUrl if url is not available.
 * If no URL is available, returns empty object.
 */
export const getTermsUrl = (termsVersion?: TermsVersion) => {
  if (termsVersion?.url) {
    return {
      embeddedUrl: termsVersion.url,
      fullScreenUrl: termsVersion.url,
    };
  }

  if (termsVersion?.fileUrl) {
    return {
      embeddedUrl: `https://drive.google.com/viewerng/viewer?embedded=true&url=${termsVersion.fileUrl}`,
      fullScreenUrl: termsVersion.fileUrl, // Not using google viewer in case a customer's firewall blocks it which does happen for at least one customer
    };
  }

  return {};
};
